/**
 * Mobile bottom bar action items.
 *
 * Bar entries carrying data-bottom-action — the declarative social bar's Menu/Search/CTA,
 * and CMS bottom_menu items whose URL is an action (#sidebar, #search, #deposit, #buy-gc;
 * see casino/partials/header/bottom_menu.blade.php) — delegate their click to the existing
 * header trigger, so the bar never duplicates the sidebar/search/deposit wiring.
 *
 * Document-level delegation keeps this inert on pages without the bar.
 */
const ACTION_TRIGGERS: Record<string, string> = {
    sidebar: '#show-sidebar',
    search: '[data-search-trigger]',
    'buy-gc': '.buy-gc-btn',
    deposit: '.btn-header-deposit, .buy-gc-btn',
};

document.addEventListener('click', (event) => {
    const item = (event.target as Element | null)?.closest<HTMLElement>('.bottom-menu [data-bottom-action]');
    if (!item) {
        return;
    }

    event.preventDefault();

    const selector = ACTION_TRIGGERS[item.getAttribute('data-bottom-action') ?? ''];
    const trigger = selector ? document.querySelector<HTMLElement>(selector) : null;
    trigger?.click();
});
